export default __webpack_public_path__ + "static/media/NotificationWorkspaceIcon.911d78fb.svg";